import { TooltipTrigger } from '../../../../Provider/TooltipManager.js'
import { ChevronDownIcon } from '@heroicons/react/24/outline/index.js'
import type { OrderContextActionsProps } from './OrderContextActionsWidget.js'
import React from 'react'

export const DropdownButton = (props: {
  label: string | React.ReactNode
  disabled?: boolean
  tooltip?: string
  children: React.ReactNode[]
  props: OrderContextActionsProps
  listClasses?: string
  triggerClasses?: string
}) => {
  if ((!props.children || props.children.length <= 0) && props.props.hideDisabled) {
    return <></>
  }
  return (
    <TooltipTrigger tooltip={props.tooltip} disabled={props.disabled !== true}>
      <div className="dropdown dropdown-end">
        <button
          className={`btn btn-sm ${props.triggerClasses ?? ''}`}
          style={{ borderRadius: 0, borderWidth: 0 }}
          tabIndex={0}
          disabled={props.disabled === true}
          data-testid={`dropdown-button-${props.label}`}
        >
          {props.label}
          <ChevronDownIcon className="w-4 h-4 ml-2" />
        </button>
        <ul tabIndex={0} className={`dropdown-content z-50 menu p-2 shadow-sm bg-base-100 rounded-box w-fit sm:max-md:w-full ${props.listClasses ?? ''}`}>
          {props.children}
        </ul>
      </div>
    </TooltipTrigger>
  )
}
